import VMasker from 'vanilla-masker';

export const maskCPF = (text) => {
    return VMasker.toPattern(text, '999.999.999-99');
}

// export const maskCNPJ = (text) => {
//     return VMasker.toPattern(text, '99.999.999/9999-99');
// }

export const maskDate = (text) => {
    return VMasker.toPattern(text, '99/99/9999');
}

export const maskHora = (text) => {
    return VMasker.toPattern(text, '99:99');
}

export const maskTelefone = (text) => {
    return VMasker.toPattern(text, '(99)99999-9999');
}

export const maskNumber = (text) => {
    return VMasker.toNumber(text);
}

export const maskDecimal = (text) => {
    return VMasker.toMoney(text, {
        // Decimal precision -> "90"
        precision: 2,
        // Decimal separator -> ",90"
        separator: ',',
        // Number delimiter -> "12.345.678"
        delimiter: '.',

        // Money unit -> "R$ 12.345.678,90"
        // unit: 'R$',

        // Money unit -> "12.345.678,90 R$"
        // suffixUnit: 'R$',

        // Force type only number instead decimal,
        // masking decimals with ",00"
        // Zero cents -> "R$ 1.234.567.890,00"
        zeroCents: true
    });
}





export const somenteNumeros = (value = '') => {
    return String(value || '').replace(/[^0-9]/g, '');
}

export const somenteAlfaNumerico = (value = '') => {
    return String(value || '').replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
}

export const limparCpfCnpj = (value = '') => {
    const texto = String(value || '').toUpperCase();

    // Se tiver letra, é CNPJ alfanumérico
    if (/[A-Z]/.test(texto)) {
        return somenteAlfaNumerico(texto);
    }

    return somenteNumeros(texto);
}

export const maskCNPJ = (text) => {
    const value = somenteAlfaNumerico(text).substring(0, 14);

    if (!value) return '';

    const p1 = value.substring(0, 2);
    const p2 = value.substring(2, 5);
    const p3 = value.substring(5, 8);
    const p4 = value.substring(8, 12);
    const p5 = value.substring(12, 14);

    let result = p1;

    if (p2) result += '.' + p2;
    if (p3) result += '.' + p3;
    if (p4) result += '/' + p4;
    if (p5) result += '-' + p5;

    return result;
}

export const maskCpfCnpj = (text) => {
    const value = limparCpfCnpj(text);

    if (!value) return '';

    if (/^[0-9]{1,11}$/.test(value)) {
        return maskCPF(value);
    }

    return maskCNPJ(value);
}


// WEBPACK FOOTER //
// ./src/utils/Masker.js